import { createSelector } from '@reduxjs/toolkit';
// @ts-expect-error Untyped import
import { getAllAgentResponders } from './getAllAgentResponders';
export const getAgentRespondersList = createSelector([getAllAgentResponders], agentRespondersMap => agentRespondersMap.toList());